import { Skeleton } from '@leadsnavi/ui-kit';

/**
 * 骨架屏卡片 — 严格按照 Figma node 11042-97864 实现
 *
 * 卡片结构（对应 Figma 层级）：
 * 根: padding 16px, gap 20px, bg #FFFFFF, border-radius 8px
 * └─ Frame 2147225351  (column, gap 16px)
 *      ├─ Frame 2147225350  (column, gap 8px)
 *      │    ├─ Frame 2147225271  (row, center, gap 8px)
 *      │    │    ├─ Avatar      28×28, border-radius 14px, #E5E5E5
 *      │    │    └─ 文字条      flex-1, h-3.5, border-radius 2px, #E5E5E5
 *      │    └─ Frame 2147225270  (row, center, gap 4px, fill)
 *      │         └─ 标签组      3 × (w-13 h-3.5), border-radius 2px, #E5E5E5
 *      └─ Frame 2147225116  (column, justify-center, gap 8px, fill)
 *           ├─ 全宽条           w-full h-3.5, border-radius 2px, #E5E5E5
 *           └─ 短条             w-22 h-3.5, border-radius 2px, #E5E5E5
 */
export function SearchCardV2SkeletonItem() {
  return (
    /* 根卡片: bg #FFFFFF, border-radius 8px, padding 16px, column gap-5 */
    <div className="bg-white rounded-lg p-4 flex flex-col gap-5">
      {/* Frame 2147225351: column gap-4 */}
      <div className="flex flex-col gap-4">
        {/* Frame 2147225350: column gap-2 */}
        <div className="flex flex-col gap-2">
          {/* Frame 2147225271: row, items-center, gap-2 */}
          <div className="flex items-center gap-2">
            {/* Avatar: 28×28, border-radius 14px (≈ rounded-[14px]), #E5E5E5 */}
            <Skeleton className="w-7 h-7 shrink-0 rounded-[14px]" />
            {/* Rectangle 240648687: 305×14, border-radius 2px, flex-1 */}
            <Skeleton className="flex-1 h-3.5 rounded-[2px]" />
          </div>

          {/* Frame 2147225270: row, items-center, gap-1, fill width */}
          {/* 含 3 个 52×14 的标签骨架，gap 4px */}
          <div className="flex items-center gap-1">
            <Skeleton className="w-13 h-3.5 rounded-[2px]" />
            <Skeleton className="w-13 h-3.5 rounded-[2px]" />
            <Skeleton className="w-13 h-3.5 rounded-[2px]" />
          </div>
        </div>

        {/* Frame 2147225116: column, justify-center, gap-2, fill width */}
        <div className="flex flex-col justify-center gap-2">
          {/* 全宽文本行: fill×14 */}
          <Skeleton className="w-full h-3.5 rounded-[2px]" />
          {/* 短文本行: 88×14 */}
          <Skeleton className="w-22 h-3.5 rounded-[2px]" />
        </div>
      </div>
    </div>
  );
}
